<button mat-icon-button (click)="openBottomSheet()" style="color: rgb(45, 97, 99);">
  <mat-icon [matBadge]="quantityPassword" matBadgeSize="small" matBadgeOverlap="false"
    style="color: rgb(45, 97, 99);">confirmation_number</mat-icon>
</button>